<template>
    <div class="assess-container">
        <div v-if="data.has_audit-0 === 1" class="success-container">
            <div class="success">
                <i></i>
            </div>
            <p>审核通过</p>
        </div>
        <div v-if="data.has_audit-0 === 2" class="fail-container">
            <div @mouseenter="enter" @mouseleave="leave" class="btn">
                <div v-if="!showReAudit" class="fail">
                    <i></i>
                    <p>技审未通过</p>
                </div>
                <div @click="videoAudit" v-if="showReAudit && !data.isStream" class="rec">
                    重新审计
                </div>
            </div>
        </div>
        <div v-if="data.audit_status-0 === 3 && data.audit_res.result.length > 0" class="list-container">
            <div class="line">
                <p class="left">
                    时间
                </p>
                <p class="right">
                    结果
                </p>
            </div>
            <ul>
                <li v-for="(item,index) in data.audit_res.result" :key="index">
                    <div @click="toTime(item.startTime)" class="left">
                        <p>{{item.startTimeStr}} {{item.endTimeStr}}</p>
                    </div>
                    <div class="right">{{item.label}}</div>
                </li>
            </ul>
        </div>
        <newMaterialLoad v-if="data.audit_status-0 === 2"></newMaterialLoad>
        <newMaterialNoResult v-if="data.audit_status-0 === 1 || data.audit_status-0 === 4"></newMaterialNoResult>
    </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";

export default {
    name: 'newMaterialAssess',
    data() {
        return {
            showReAudit: false
        }
    },
    props: {
        data: {
            type: Object
        }
    },
    methods: {
        toTime(s) {
            console.log(s)
            this.$emit('toTime', s/10)
        },
        enter() {
            this.showReAudit = true;
        },
        leave() {
            this.showReAudit = false;
        },
        videoAudit() {
            const info = {
                idstring: this.data.idstring,
            };

            common.myFetch(apis.videoAudit, { data: info, hideLoading: true }).then(r => {
                if (r) {
                    this.data.audit_status = 2
                    this.data.has_audit = 0
                    console.log(r)
                }
            })
        }
    },
    mounted() {
        if(this.data.has_audit_role&&this.data.has_audit<=0&&(this.data.audit_status!=2&&this.data.audit_status!=3)){
            this.videoAudit()
        }else if(this.data.has_audit_role&&this.data.has_audit>0&&(this.data.audit_status-0>=3)){

        }
    }
}
</script>

<style lang="less" scoped>
    .assess-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 14px 20px 0;
        box-sizing: border-box;

        .success-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 120px;

            .success {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100px;
                height: 100px;
                border-radius: 50%;
                background: rgba(65, 180, 140, 0.15);
                margin-bottom: 10px;

                i {
                    display: block;
                    width: 46px;
                    height: 46px;
                    background: url('../../../common/newMaterialBox/assets/assessSuccess.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                }
            }

            p {
                font-size: 14px;
                line-height: 20px;
                color: #050F0F;
                font-weight: 500;
            }
        }

        .fail-container {
            width: 100%;

            .btn {
                width: 100%;
                height: 32px;
                user-select: none;
                cursor: pointer;

                .fail {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    border-radius: 4px;
                    border: 1px solid #FF555A;
                    box-sizing: border-box;

                    i {
                        display: block;
                        width: 16px;
                        height: 16px;
                        background: url('../../../common/newMaterialBox/assets/failIcon.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-right: 8px;
                    }

                    p {
                        font-size: 14px;
                        line-height: 20px;
                        color: #FF555A;
                    }
                }

                .rec {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    border-radius: 4px;
                    background: #41B48C;
                    border: 1px solid #41B48C;
                    color: #FFF;
                    box-sizing: border-box;
                }

            }
        }

        .list-container {
            display: flex;
            flex-direction: column;
            width: 100%;
            flex: 1;
            min-height: 0;

            .line {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 100%;
                height: 28px;
                line-height: 28px;
                font-size: 13px;
                color: #829191;
                background: rgba(185, 195, 195, 0.2);
                margin-top: 14px;

                .left {
                    width: 150px;
                    height: 100%;
                    padding-left: 35px;
                    box-sizing: border-box;
                }

                .right {
                    flex: 1;
                    height: 100%;
                }
            }

            ul {
                display: flex;
                flex-direction: column;
                flex: 1;
                min-height: 0;
                overflow-y: auto;

                &::-webkit-scrollbar {
                    width: 6px;
                }
                &::-webkit-scrollbar-thumb {
                    background: rgba(#D8D8D8, 1);
                    border-radius: 5px;
                }

                li {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    min-height: 60px;
                    padding: 14px 20px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #F0F0F0;

                    &:hover {
                        background: rgba(185, 195, 195, 0.08);
                    }

                    .left {
                        width: 130px;

                        p {
                            width: 70px;
                            display: flex;
                            flex-wrap: wrap;
                            font-size: 14px;
                            line-height: 16px;
                            color: #050F0F;
                            padding: 0;
                            margin: 0;
                        }
                    }

                    .right {
                        display: flex;
                        flex-wrap: wrap;
                        flex: 1;
                        font-size: 14px;
                        line-height: 20px;
                        color: #050F0F;
                    }
                }
            }
        }
    }
</style>